import CardDesignerCardElementOpacityControls from './CardDesignerCardElementOpacityControls';

export default CardDesignerCardElementOpacityControls;
